/**
 *
 * @description  The TemplateModel extends BaseModel, and whose primary function
 * is to transact top level form data with a remote service (which in the case of
 * Cayuse is the eform service).  The attribute children is a Backbone.Collection
 * of TemplateObjectModels and represents the tree structure and current state
 * of all template objects of a given form.
 *
 * @module "model/template.model"
 *
 */

define('formkit/model/template.model',['require','exports','module','underscore','./base.model','./template.object.model'],function(require, exports, module) {
  //prettier-ignore
  var _                   = require('underscore'),
      BaseModel           = require('./base.model'),
      TemplateObjectModel = require('./template.object.model');

  /**
   * @class TemplateModel
   * @augments BaseModel
   * @see {@link model/base.model}
   * @property {Object} childModels - an object containing a child TemplateObjectModel
   */
  var TemplateModel = BaseModel.extend({
    /**
     * @lends TemplateModel.prototype
     * @method defaults
     * @returns {Object} a default child array
     */
    defaults: function() {
      return {
        children: [],
      };
    },

    childModels: {
      children: TemplateObjectModel,
    },

    /**
     * fetch - extends the fetch options with isFromServer set to true and
     * requestTimestamp set to the current time of the request.
     *
     * @override
     * @param  {Object} options options to pass to fetch
     * @returns {Object} fetched BaseModel
     */
    fetch: function(options) {
      return BaseModel.prototype.fetch.call(
        this,
        _.extend(
          {
            isFromServer: true,
            requestTimestamp: new Date().getTime(),
          },
          options
        )
      );
    },

    /**
     * save - extends the attributes currently being saved with isFromServer set
     * to true and requestTimestamp set to the current time fo the request.
     *
     * @override
     * @param  {Object} attrs   attributes to pass to save
     * @param  {Object} options options to pass to save
     * @returns {Object} saved BaseModel
     */
    save: function(attrs, options) {
      return BaseModel.prototype.save.call(
        this,
        attrs,
        _.extend(
          {
            isFromServer: true,
            requestTimestamp: new Date().getTime(),
          },
          options
        )
      );
    },
  });

  module.exports = TemplateModel;
});

